import { Gateway, httpClient } from './base/httpClient';
import { environment } from '../environments/environment';
import '../shared/prototype/storage.prototype'

export async function setAuthorization() {
    var data = {
        grant_type: 'client_credentials'
    }

    var apiResult = await fetch(Gateway + "/oauth/v1/access-token", {
        method: "POST",
        body: formEncode(data),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": `Basic ${environment.credential}`
        }
    });

    var response = await apiResult.json();
    localStorage.setItem("auth_", "bearer " + response.access_token);
}

export function getAuthorization() {
    var tokenKey = localStorage.getItem("auth_") ?? "";
    return tokenKey;
}

function formEncode(body: object): string {
    let formBody: string[] = [];
    for (let property in body) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(body[property]);
        var value = encodedKey + "=" + encodedValue;
        formBody.push(value);
    }

    return formBody.join("&");
}